import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CourseTemplateManageSummaryModel } from 'src/app/models/course/course-template-manage-summary.model';
import { TableColumn } from 'src/app/models/table-column.model';
import { TrainingTypeModel } from 'src/app/models/training/training-type.model';
import { getTrainingTypeLabel } from 'src/app/utils/training-type.utils';

@Component({
  selector: 'app-archive-elernings-modal',
  templateUrl: './archive-elernings-modal.component.html',
  styleUrls: ['./archive-elernings-modal.component.scss'],
  standalone: false
})
export class ArchiveElerningsModalComponent {
  @Input() showModal = false;
  @Input() elernings: CourseTemplateManageSummaryModel[] = [];

  elerningColumns: TableColumn[] = [
    {
      caption: this.translateService.instant('COMMON.FIELDS.NAME'),
      dataField: 'name',
      cssClass: 'width-150',
      cellValue: (data: CourseTemplateManageSummaryModel): string => {
        return (
          data.name +
          (data.isDeployed
            ? ''
            : ` - ${this.translateService.instant(
                'MANAGE-ELEARNING.OVERVIEW.DRAFT'
              )}`)
        );
      },
    },
    {
      caption: this.translateService.instant('COMMON.FIELDS.TRAINING-TYPE'),
      dataField: 'trainingType',
      cellValue: (data: CourseTemplateManageSummaryModel): string => {
        return getTrainingTypeLabel(data.trainingType, this.translateService)
      },
    },
    {
      caption: this.translateService.instant('COMMON.FIELDS.STATUS'),
      dataField: 'isDeployed',
      cellValue: (data: CourseTemplateManageSummaryModel): string => {
        return data.isDeployed
          ? this.translateService.instant('COMMON.EVENT-STATUS.DEPLOYED')
          : this.translateService.instant('COMMON.EVENT-STATUS.DRAFT');
      },
    },
    {
      caption: this.translateService.instant('COMMON.FIELDS.TRAINING-GROUPS'),
      dataField: 'trainingGroups',
      cssClass: 'width-250',
      headerFilter: (data: any) => {
        data.dataSource.postProcess = (results: any) => {
          const trainingGroupNames = results.reduce(
            (a: any, b: any) => a.concat(b.value),
            []
          );
          const parsedTrainingGroupNames: string[] = [];
          trainingGroupNames.forEach((group: string) => {
            if (!group || !group.includes(', ')) {
              parsedTrainingGroupNames.push(group);
            } else if (group.includes(', ')) {
              const groups = group.split(', ');
              parsedTrainingGroupNames.push(...groups);
            }
          });
          const uniqueTrainingGroupNames = [
            ...new Set(parsedTrainingGroupNames),
          ];

          results.splice(0, results.length);
          uniqueTrainingGroupNames.forEach((tgName) => {
            if (tgName) {
              results.push({
                text: tgName,
                value: tgName,
              });
            } else {
              results.push({
                text: '(Blanks)',
                value: null,
              });
            }
          });
          return results;
        };
      },
      filterExpression: (value: any) => {
        function getTrainingGroupsFilterString(rowData: CourseTemplateManageSummaryModel) {
          const groups = rowData.trainingGroups.map((tg) => tg.name);
          return !!groups.join(',') ? groups.join(',') + ',' : 'empty';
        }

        return [
          [
            getTrainingGroupsFilterString,
            'contains',
            value ? value + ',' : 'empty',
          ],
        ];
      },
      cellValue: (data: CourseTemplateManageSummaryModel): string => {
        return data.trainingGroups.map((tg: any) => tg.name).join(', ');
      },
    }
  ];

  @Output() showModalChange = new EventEmitter<boolean>();
  @Output() submit = new EventEmitter();

  constructor(private translateService: TranslateService) {}

  dismiss = () => {
    this.showModal = false;
    this.showModalChange.emit(this.showModal);
  };

  onSubmit = () => {
    this.submit.emit();
    this.showModal = false;
    this.showModalChange.emit(this.showModal);
  };
}
